/** Ajusta hash do embed Metabase para acompanhar claro/escuro do dash. */
export function withMetabaseTheme(iframeUrl: string, resolvedTheme: 'light' | 'dark'): string {
  const [path, hash = ''] = iframeUrl.split('#');
  const params = new URLSearchParams(hash.replace(/^\?/, ''));

  params.set('bordered', 'true');
  params.set('titled', 'true');

  if (resolvedTheme === 'dark') {
    params.set('theme', 'night');
  } else {
    params.delete('theme');
  }

  return `${path}#${params.toString()}`;
}
